export default __webpack_public_path__ + "static/media/closet5-after1-768w.0969647d.png";